import { InjectionToken } from '@angular/core';

import { ISnAuthConfig } from '../interfaces/auth-config.interface';

export const SN_AUTH_CONFIG = new InjectionToken<ISnAuthConfig>('SN_AUTH_CONFIG');

export function authConfigFactory(config: Partial<ISnAuthConfig>): ISnAuthConfig {
  return {
    signUpEnabled: false,
    ssoEnabled: false,
    redirectAuthorizedTo: '/',
    isRegistry: false,
    isVideoMeet: false,
    ...config,
  };
}
